// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import { protocol, origin, getHeaders } from './addons'
import Notifications from 'react-notification-system-redux'
import {
  addKeywordSuccess,
  delKeywordSuccess,
  addKeywordError,
  delKeywordError
} from './toasts'

export const GET_KEYWORDS = 'GET_KEYWORDS'

// ------------------------------------
// Actions
// ------------------------------------
const getKeywordsAction = (data = undefined) => {
  return {
    type: GET_KEYWORDS,
    data: data
  }
}

export const getKeywords = () => {
    return (dispatch) => {
        return new Promise((resolve) => {
          axios.get(`${protocol}//${origin}/api/keywords`, getHeaders())
            .then((json) => {
              dispatch(getKeywordsAction(json.data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
    }
  }

  export const addKeyword = (data) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.post(`${protocol}//${origin}/api/keywords`, data, getHeaders())
          .then((json) => {
            dispatch(Notifications.success(addKeywordSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(addKeywordError))
            resolve()
          })
      })
    }
  }

  export const updateKeyword = (data, id) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.put(`${protocol}//${origin}/api/keywords/${id}`, data, getHeaders())
          .then((json) => {
            dispatch(Notifications.success(addKeywordSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(addKeywordError))
            resolve()
          })
      })
    }
  }
  export const deleteKeyword = (id) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.delete(`${protocol}//${origin}/api/keywords/${id}`, getHeaders())
          .then((response) => {
            dispatch(Notifications.success(delKeywordSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(delKeywordError))
            resolve()
          })
      })
    }
  }

export const actions = { getKeywords, addKeyword, deleteKeyword, updateKeyword }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_KEYWORDS]: (state, action) => {
    return {
      ...state,
      keywords: action.data
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  keywords: []
}

export default function keywordReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/keyword.js